import useMediaQuery from '@mui/material/useMediaQuery'
import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {
  addChatRequestsUp,
  addNewNotificationCount,
  addNotifications,
  addNotificationToStack,
  addNotificationUp,
  addToPersonalStack,
  ChatRequest,
  GetNotificationsRequest,
  NeutralNotificationTypes,
  NotificationType,
  NotificationTypes
} from 'entities/activity'
import {useConnectSocket} from 'entities/app'
import {socket} from 'entities/app/socket'

export const ActivitySocket = () => {
  const dispatch = useDispatch()
  const is1280p = useMediaQuery('(max-width: 1279px)')
  const is768p = useMediaQuery('(max-width: 767px)')
  const connectSocket = useConnectSocket()

  useEffect(() => {
    GetNotificationsRequest()
      .then(({data}) => dispatch(addNotifications(data)))
      .catch(console.error)
  }, [connectSocket])

  useEffect(() => {
    const activityChatRequestHandler = (chatRequest: ChatRequest) => {
      dispatch(addChatRequestsUp(chatRequest))
      is1280p && dispatch(addNewNotificationCount())

      is768p && dispatch(addToPersonalStack({type: 'chat-request', item: chatRequest}))
    }

    socket && socket.on('activity.chat_request', activityChatRequestHandler)

    return () => {
      socket && socket.off('activity.chat_request', activityChatRequestHandler)
    }
  }, [socket, is768p, is1280p])

  useEffect(() => {
    const activityNotificationHandler = (notification: NotificationType) => {
      !is768p && dispatch(addNotificationToStack(notification))

      if (is768p) {
        if (
          notification.type === NotificationTypes.VISIT ||
          notification.type === NotificationTypes.POSSIBLE_MATCH ||
          notification.type === NeutralNotificationTypes.ONLINE ||
          notification.type === NeutralNotificationTypes.PHOTO_UPLOADED
        ) {
          dispatch(addNotificationToStack(notification))
        }

        if (
          notification.type === NotificationTypes.FAVORITE ||
          notification.type === NotificationTypes.LIKE ||
          notification.type === NotificationTypes.MATCH
        ) {
          dispatch(addToPersonalStack({type: 'notification', item: notification}))
        }
      }

      if (
        notification.type === NotificationTypes.FAVORITE ||
        notification.type === NotificationTypes.LIKE ||
        notification.type === NotificationTypes.MATCH ||
        notification.type === NotificationTypes.VISIT ||
        notification.type === NotificationTypes.POSSIBLE_MATCH
      ) {
        dispatch(addNotificationUp(notification))
      }
    }

    socket && socket.on('activity.notification', activityNotificationHandler)

    return () => {
      socket && socket.off('activity.notification', activityNotificationHandler)
    }
  }, [socket, is768p])

  return <></>
}